import { ILand, IPlantCulture } from "./ILand";
import {
  ISimpleObject,
  ISimpleObjectWithCode,
} from "@inceptionbg/ui-components";
import { IFarm } from "./IFarm";

export interface IFieldBook {
  uuid: string;
  name: string;
  fieldLands: IFieldLand[];
  farm: Partial<IFarm>;
}

export interface IFieldLand {
  uuid: string;
  land: ILand;
}

export type FieldBookFetchOptions = "FIELD_LANDS" | "FARM";

export interface IFieldEntry {
  uuid: string;
  type: IEntryType;
  activityDate: string;
  unitOfMeasure: string;
  quantity: string;
  expense: string;
  income: string;
  description: string;
  activity: Partial<IActivity>;
  laborType: Partial<ILaborType>;
  treatmentAgent: Partial<ITreatmentAgent>;
  plantCulture: Partial<IPlantCulture>;

  field: Partial<IFieldBook>;
  activityGroup: ISimpleObject;
  laborTypeGroup: ISimpleObject;
  treatmentAgentType: ISimpleObjectWithCode;
  pricePerUnit: string;
}

export type FieldEntryOptions =
  | "PLANT_CULTURE"
  | "ACTIVITY"
  | "LABOR_TYPE"
  | "FIELD"
  | "TREATMENT_AGENT";

export const EntryTypes = [
  "ACTIVITY",
  "PROTECTION_AND_NUTRITION",
  "FUEL_CONSUMPTION",
  "DIRECT_COSTS",
  "YIELD",
  "ANOTHER_INCOME_ENTRY",
] as const;
export type IEntryType = (typeof EntryTypes)[number];

export interface IActivity {
  uuid: string;
  code: string;
  name: string;
  note: string;
  activityGroup: ISimpleObject;
}
export type ActivityFetchOptions = "ACTIVITY_GROUP";

export interface ILaborType {
  uuid: string;
  code: string;
  name: string;
  note: string;
  laborTypeGroup: ISimpleObject;
}
export type LaborTypeFetchOptions = "LABOR_TYPE_GROUP";

export interface ITreatmentAgent {
  uuid: string;
  code: string;
  name: string;
  note: string;
  activeSubstance: string;
  unit: string;
  treatmentAgentGroup: ISimpleObject;
  treatmentAgentType: ISimpleObjectWithCode;
}
// export type TreatmentAgentFetchOptions =
//   | "TREATMENT_AGENT_GROUP"
//   | "TREATMENT_AGENT_TYPE";

export interface IFieldEntryRecapitulationItem {
  field: IFieldBook;
  plantCulture: IPlantCulture;
  expense: number;
  income: number;
  profit: number;
}

export interface IFieldEntryRecapitulationFilters {
  fieldUuid?: string;
  plantCultureUuid?: string;
  periodFrom?: string;
  periodTo?: string;
}

export interface IFieldEntryRecapitulationData {
  items: IFieldEntryRecapitulationItem[];
  totalIncome: number;
  totalExpenses: number;
  netProfit: number;
}

export interface IFieldEntryReportFilters {
  farmUuid?: string;
  fieldEntryType?: IEntryType;
  fieldUuid?: string;
  plantCultureUuid?: string;
  periodFrom?: string;
  periodTo?: string;
  fieldObj?: { value: string; label: string } | null;
  plantCultureObj?: { value: string; label: string } | null;
  entryTypeObj?: { label: string; value: IEntryType } | null;
}

export interface IFieldEntryTypeReport {
  type: IEntryType;
  expense: number;
  income: number;
}

export interface ILaborTypeReport {
  laborType: ILaborType;
  quantity: number;
  expense: number;
}

export interface IFieldEntryRecapitulation {
  field: IFieldBook;
  plantCulture: IPlantCulture;
  expense: number;
  income: number;
  profit: number;
}

export interface IFieldEntryReportData {
  fieldEntryTypeReport: IFieldEntryTypeReport[];
  laborTypeReport: ILaborTypeReport[];
  fieldEntryRecapitulations: IFieldEntryRecapitulation[];
}
